import { useEffect } from 'react';
import { useAuthentication } from '@johnlewispartnership/wtr-website-authentication/dist/context';
import { useAnalytics } from '@johnlewispartnership/wtr-website-analytics';
import config from 'config';
import locator from 'locator';
import shoppingContextService from 'services/shoppingContext';
import { CustomerOrderState } from 'services/shoppingContext/types';

export type PurchaseOrAmendType = 'purchase' | 'amend';

const getPurchaseOrAmend = async (authHeader?: string): Promise<PurchaseOrAmendType> => {
  if (!authHeader) return 'purchase';

  try {
    const shoppingContext = await shoppingContextService.getShoppingContext(authHeader);

    return shoppingContext.customerOrderState === CustomerOrderState.AMENDING
      ? 'amend'
      : 'purchase';
  } catch {
    return 'purchase';
  }
};

const PageViewTrackerEvent = () => {
  const { state } = useAuthentication();
  const { initialised, token, isLoggedIn } = state;
  const { trackVirtualPageView } = useAnalytics();

  useEffect(() => {
    if (!initialised) {
      return;
    }

    let cancelled = false;

    const trackPageView = async () => {
      const purchaseOrAmend = await getPurchaseOrAmend(token?.authHeader);

      if (cancelled) return;

      trackVirtualPageView({
        authenticated: isLoggedIn,
        location: window.location.href,
        path: locator.pathname,
        previous_path: document.referrer,
        service_name: config.applicationName,
        title: document.title,
        purchase_or_amend: purchaseOrAmend,
        type: 'cms',
      });
    };

    trackPageView();

    return () => {
      cancelled = true;
    };
  }, [initialised, isLoggedIn, token, trackVirtualPageView]);

  return null;
};

export default PageViewTrackerEvent;
